import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que dejar de comer carbohidratos?',
  answer: 'No. Aprenderás a comer los carbohidratos correctos en el momento correcto para que trabajen para tu energía, no para tu cintura. De hecho, la mañana es el mejor momento del día para disfrutarlos.'
}, {
  question: '¿Funciona si ya estoy en terapia de reemplazo hormonal (TRH)?',
  answer: 'Absolutamente. Este sistema optimiza la forma en que tu cuerpo procesa cualquier soporte hormonal médico que estés recibiendo. De hecho, las mujeres en TRH que combinan ambas intervenciones reportan resultados superiores.'
}, {
  question: '¿Cuánto tiempo necesito al día?',
  answer: 'El sistema está diseñado para mujeres ocupadas. Solo necesitas 15-20 minutos al día para preparar tus comidas siguiendo el protocolo de sincronización hormonal. No hay rutinas complicadas ni recetas elaboradas.'
}, {
  question: '¿Necesito comprar suplementos caros?',
  answer: 'No. Este programa se basa en alimentos reales y accesibles que puedes encontrar en cualquier supermercado. El Bono #3 de Suplementación de Precisión te dirá exactamente qué es imprescindible y qué es un gasto innecesario.'
}, {
  question: '¿Funciona si tengo más de 55 años?',
  answer: 'Sí. El sistema funciona para cualquier mujer en la etapa de la menopausia, sin importar si estás en la perimenopausia, menopausia o postmenopausia. Algunas de nuestras participantes más entusiastas tienen más de 60 años.'
}, {
  question: '¿Tengo que hacer ejercicio intenso?',
  answer: 'No. De hecho, el cardio intenso en ayunas puede ser contraproducente después de los 40 porque eleva el cortisol. El programa incluye recomendaciones de movimiento suave y estratégico — caminatas y entrenamiento de fuerza moderado post-comida — que sí funcionan para tu biología.'
}, {
  question: '¿Qué pasa si tengo hipotiroidismo?',
  answer: 'El protocolo es compatible con el hipotiroidismo, con pequeños ajustes en la ventana de ayuno. Siempre recomendamos consultar con tu médico antes de iniciar cualquier cambio nutricional si tienes una condición tiroidea diagnosticada.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-20 md:py-28" data-id="element-54">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-56">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-4 text-center" data-id="element-57">
            Preguntas Frecuentes
          </h2>
          <p className="text-center text-charcoal/60 text-base md:text-lg mb-14" data-id="element-58">
            Resolvemos las dudas más importantes antes de empezar.
          </p>

          <div className="space-y-3" data-id="element-59">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.06
            }} className="bg-warm-white rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] overflow-hidden border border-charcoal/5" data-id="element-60">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 md:px-7 py-5 md:py-6 flex items-center justify-between text-left hover:bg-cream/40 transition-colors gap-4" aria-expanded={isOpen} aria-controls={`faq-answer-${index}`} data-id="element-61">
                    <span className="font-serif text-base md:text-lg lg:text-xl text-charcoal leading-snug" data-id="element-62">
                      {faq.question}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="flex-shrink-0" data-id="element-63">
                      <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-64" />
                    </motion.div>
                  </button>

                  <AnimatePresence initial={false} data-id="element-65">
                    {isOpen && <motion.div key="content" id={`faq-answer-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  height: {
                    duration: 0.35,
                    ease: 'easeInOut'
                  },
                  opacity: {
                    duration: 0.25,
                    ease: 'easeInOut'
                  }
                }} className="overflow-hidden" data-id="element-66">
                        <div className="px-5 md:px-7 pb-6 text-charcoal/75 text-sm md:text-base lg:text-lg leading-relaxed" data-id="element-67">
                          {faq.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}